//var ReceiveChunkSize = 1024;
//var SendChunkSize = 1024;

import TradingBlockRemote from '@/services/TradingBlockRemote';

function getParamValue(p) {
    return p.split('=')[1]
}

function quotesToLists(symbols) {
    let singles = [];
    let spreads = [];
    // console.log(symbols)
    symbols.map((sym) => {

        if (sym.OrderClass == 2)

          spreads.push({
            Bid:0,Ask:0,Last:0,Change:0,SpreadTime:"0001-01-01T00:00:00",
            Type: 0, // calendar is bug
            Legs: [{Symbol: '.'+sym.Legs[0].Symbol, AssetType:2}, {Symbol: '.'+sym.Legs[1].Symbol,AssetType:2}]
          });
        else
           singles.push(sym.Symbol || sym.UnderlyingSymbol);
    });

    return {
        singles, spreads
    }
}

function getAccountPrefix() {
  return "0=" + TradingBlockRemote.getToken() + "|1=" + TradingBlockRemote.ActiveAccountId;
}

export default function createStreamingPlugin(remote) {

  let ws= null;
  let pingInterval = null;
  let pong = null;
  let connected = false;
  let remaining_tries = 2;
  let subscribed = {};
  let accountPrefix = null;

  let store;
  const handleMessage = (msg)=> {

    var a = msg.split('|');
    if (getParamValue(a[0]) != 0){
        console.log("WS Resp Code =" + a[0]);
        if (remaining_tries>0){
            remaining_tries--;
            Reconnect();
        } else {
            Disconnect();
        }
        ws.close();
        store.commit('TB_WS_ERROR', a[0]);
        return;
    }
    //console.log(a[0].split('=')[1]);
    switch (getParamValue(a[1])) {
      case '0':
        //hearbeat ignore
        break;
      case '1':
        remaining_tries = 2;
        var o = {
          Date: new Date(getParamValue(a[2])),
          Symbol: getParamValue(a[3]),
          last_trade_price: parseFloat(getParamValue(a[4])),
          bid: parseFloat(getParamValue(a[5])),
          ask: parseFloat(getParamValue(a[6])),
          ActualNetChange: parseFloat(getParamValue(a[7])),

          high: parseFloat(getParamValue(a[8])),
          low: parseFloat(getParamValue(a[9])),
          volume:  parseFloat(getParamValue(a[10])),
          change_percent: parseFloat(getParamValue(a[11])),

        };
        o.from='websocket';
        if (o.bid>0  && o.ask>0){
          store.commit('orders/updateRealtimeBySymbol', o);
        }
        if (o.last_trade_price>0) {
          // console.log(o);
          store.dispatch('portfolio/updateRealtimeBySymbol', o);
        } else {
          store.dispatch('portfolio/addFallbackSymbol', o.Symbol);
          store.commit('portfolio/appendLog',{ message: 'Symbol '+ o.Symbol+' has 0 price from tradingblock streaming.Try GetQuotes ', level: 'warning' });
        }
        //store.dispatch('TB_WS_QUOTE', o);
        break;
      case '2':
        remaining_tries = 2;
        var o = {
          Date: new Date(getParamValue(a[2])),
          Symbol: getParamValue(a[3]),
          last_trade_price: parseFloat(getParamValue(a[4])),
          bid: parseFloat(getParamValue(a[5])),
          ask: parseFloat(getParamValue(a[6])),
          ActualNetChange: parseFloat(getParamValue(a[7]))
        };
        o.from='websocket';
        o.spread = true;
        if (o.bid>0 || o.ask>0){
          //let s= o.Symbol.split('-');;
          let sym_s =o.Symbol.split('-')
          o.Legs = [];
          o.Legs[0] = {Symbol:sym_s[0].split('_')[0].substring(1)};
          o.Legs[1] = {Symbol:sym_s[1].split('_')[0].substring(1)};
          store.commit('orders/updateRealtimeBySymbol', o);
        }
        // if (o.last_trade_price>0) {
        //     // console.log(o);
        //     store.dispatch('portfolio/updateRealtimeBySymbol', o);
        // } else {
        //   store.dispatch('portfolio/addFallbackSymbol', o.Symbol);
        //   store.commit('portfolio/appendLog',{ message: 'Symbol '+ o.Symbol+' has 0 price from tradingblock streaming.Try GetQuotes ', level: 'warning' });
        // }
        break;

      case '3':
        remaining_tries = 2;
        var o = {
          AccountId: parseFloat(getParamValue(a[2])),
          OrderId: parseFloat(getParamValue(a[3])),
          OrderTime: parseFloat(getParamValue(a[4])),
          Symbol: parseFloat(getParamValue(a[5])),
          OrderQuantity: parseFloat(getParamValue(a[6])),
          FilledQuantity: parseFloat(getParamValue(a[7])),
          OrderStatus:parseFloat(getParamValue(a[8]))
        };
        store.dispatch('orders/updateOrderFill', o);
        console.log(o);
        break;
      case '100':
        remaining_tries = 2;
        break;
      default:
        console.log("Unknown msg type =" + a[1]);

        break;
    }
  };
  const CloseRoutine=()=>{
    connected = false;

    let reason="";
    if (event.code == 1000)
      reason = "Normal closure, meaning that the purpose for which the connection was established has been fulfilled.";
    else if(event.code == 1001)
      reason = "An endpoint is \"going away\", such as a server going down or a browser having navigated away from a page.";
    else if(event.code == 1002)
      reason = "An endpoint is terminating the connection due to a protocol error";
    else if(event.code == 1003)
      reason = "An endpoint is terminating the connection because it has received a type of data it cannot accept (e.g., an endpoint that understands only text data MAY send this if it receives a binary message).";
    else if(event.code == 1004)
      reason = "Reserved. The specific meaning might be defined in the future.";
    else if(event.code == 1005)
      reason = "No status code was actually present.";
    else if(event.code == 1006)
      reason = "The connection was closed abnormally, e.g., without sending or receiving a Close control frame";
    else if(event.code == 1007)
      reason = "An endpoint is terminating the connection because it has received data within a message that was not consistent with the type of the message (e.g., non-UTF-8 [http://tools.ietf.org/html/rfc3629] data within a text message).";
    else if(event.code == 1008)
      reason = "An endpoint is terminating the connection because it has received a message that \"violates its policy\". This reason is given either if there is no other sutible reason, or if there is a need to hide specific details about the policy.";
    else if(event.code == 1009)
      reason = "An endpoint is terminating the connection because it has received a message that is too big for it to process.";
    else if(event.code == 1011)
      reason = "A server is terminating the connection because it encountered an unexpected condition that prevented it from fulfilling the request.";
    else if(event.code == 1015)
      reason = "The connection was closed due to a failure to perform a TLS handshake (e.g., the server certificate can't be verified).";

    console.log("WS close:"+ reason);
    accountPrefix = null;
    store.commit('TB_WS_CLOSE');
  };
  const ShowTbLogin=()=>{
        window.GotoLoginScreen();
  };
  const Connect=()=> {

    // pingInterval = setInterval(function()
    // {
    //   console.log("sending ping...");
    //   ws.send('ping');
    //
    //   setTimeout(function()
    //   {
    //     if (pong != null) {
    //       pong = null;
    //     } else {
    //       // do stuff here to handle no pong
    //       console.log("no pong!");
    //       clearInterval(pingInterval);
    //       try {
    //         ws.close();
    //       }
    //       catch(err) {
    //         console.error(err.message);
    //       }
    //     }
    //   },1000);
    // }, 20000);
    return new Promise((resolve, reject) => {
      ws = new WebSocket(remote)
      ws.onmessage = e => handleMessage(e.data);
      // ws.onerror = (e) => {
      //   connected = false;
      //   console.log("WS error" + e.message);
      //   store.commit('TB_WS_ERROR');
      //   reject();
      // };
      ws.onclose = CloseRoutine;
      ws.onopen = e => {

        //ws.send("0="+token+"|1="+accid+"|10=INTC")
        // Subscribe([{Symbol: "MSFT", OrderClass: 1},
        //   {Symbol: "IWM190118C00150000", OrderClass: 1},
        //   {OrderClass: 2, Legs: [{Symbol: "IWM"}, {Symbol: "AMZN"}]}
        //   //{OrderClass:2, Legs: [{Symbol:"IWM 190215C00134000"},{Symbol:"IWM 190215C00139000"}]}
        // ]);
        if ( ws.readyState == 1 ) {
          connected = true;
          accountPrefix = getAccountPrefix();
          console.log("WS open")
          store.commit('TB_WS_OPEN');
          setTimeout(function (){
            resolve();
          },200);

        }

      }
    });

  };

  const Disconnect=()=> {
      return new Promise((resolve, reject) => {
        try {
          ws.onclose = e=> {
            CloseRoutine();
            resolve();
          };
          ws.close();
        } catch (exc) {
          reject();
        }
      });
  };

  const SubscribeSingles=(syms)=> {
    ws.send(accountPrefix + "|10=" + syms.filter((v,i,a)=>a.indexOf(v)==i).join(','))
  };

  const SubscribeSpreads=(syms)=> {
    ws.send(accountPrefix + "|11=" + JSON.stringify(syms))
  };

  const SubscribeOrders=()=> {
    ws.send(accountPrefix + "|13=1");
  };

  const SubscribeQuotes=(syms)=> {
    let lists = quotesToLists(syms);
    lists.singles && lists.singles.length > 0 && SubscribeSingles(lists.singles);
    lists.spreads && lists.spreads.length > 0 && SubscribeSpreads(lists.spreads);
    subscribed = lists;
  };

  const UnsubscribeOrders=()=> {
    ws.send(accountPrefix + "|13=0");
  };

  const Reconnect= ()=> {
    return Disconnect().then(Connect);
  };

  const UnsubscribeQuotes= async (syms)=> {
    if (syms && syms.length>0) {
      subscribed.singles = subscribed.singles ? subscribed.singles.filter(o => !syms.contains(o.Symbol)) : [];
      //subscribed.spreads = subscribed.spreads ? subscribed.spreads.filter(o => !syms.contains(o.Legs[0].Symbol) && !syms.contains(o.Legs[1].Symbol)) : [];

      await Reconnect();

      subscribed.singles && subscribed.singles.length > 0 && SubscribeSingles(subscribed.singles);
      //subscribed.spreads && subscribed.spreads.length > 0 && SubscribeSpreads(subscribed.spreads);
    } else {
      await Reconnect();
    }
  };

  let pending_account= !TradingBlockRemote.authenticated;

  return (st) => {

    store = st;
    //EnsureOrShowTbLogin();
    //Connect();
    store.subscribe(async mutation => {
       if (mutation.type === 'orders/setRefreshingQuotes' ) {
         if (store.state.orders.items && store.state.orders.items.length>0) {
           if (!connected){
             await Connect();
           }
           SubscribeQuotes(store.state.orders.items);
         }
       }
      if (mutation.type === 'portfolio/setRefreshing' ) {
          if (mutation.payload) {
            pending_account= !TradingBlockRemote.authenticated;
            if (!pending_account) {
              store.state.portfolio.items && store.state.portfolio.items.length>0 && Connect().then(()=>{
                SubscribeQuotes(store.state.portfolio.items);
              });

            } else {
              //ShowTbLogin();
              //if (!tb)
              store.commit('portfolio/appendLog', {message: 'Please login at stocks page to Tradingblock to use tradingblock quotes.' , level: 'info'});
            }
          } else {
              connected && UnsubscribeQuotes();
          }


      }

      if (mutation.type === 'TB_LOGOUT') {
        pending_account = true;
      }
      if (mutation.type === 'TB_CHOOSED_SUBACCOUNT') {
          pending_account = false;
      }
      if (mutation.type === 'QUOTES_SUBSCRIBE') {
        if (!connected)
            Connect().then(un=> {
              SubscribeQuotes(mutation.payload);
            });
        else
          SubscribeQuotes(mutation.payload);
      }
      if (mutation.type === 'QUOTES_UNSUBSCRIBE') {
        if (connected)
            UnsubscribeQuotes(mutation.payload);
      }
      if (mutation.type === 'ORDERS_SUBSCRIBE') {
        if (!connected)
          Connect().then(un=> {
            SubscribeOrders(mutation.payload);
          });
        else
          SubscribeOrders(mutation.payload);
      }
      if (mutation.type === 'ORDERS_UNSUBSCRIBE') {
        if (connected)
            UnsubscribeOrders(mutation.payload);
      }
    });
  };
}